import React from 'react';
// material ui & application theming
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
// application routing and setup.
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// views & components
import SessionProvider from './context/Session';
import Navigation from './components/Navigation';
import HomeView from './views/Home';
import ForSaleView from './views/ForSaleView';
import ForSaleItemView from './views/ForSaleItemView';
import CustomOrdersView from './views/CustomOrdersView';
import GalleryView from './views/GalleryView';
import ContactView from './views/ContactView';
import AboutView from './views/AboutView';
import AccountView from './views/AccountView';
import Checkout from './views/Checkout/Checkout';
import CustomOrderDescription from './views/CustomOrders/CustomOrderDescription';
import CustomOrderStatus from './views/CustomOrders/CustomOrderStatus';
import AdminShopView from './views/Admin/AdminShopView';
import AdminOrdersView from './views/Admin/AdminOrdersView';
import AdminOrdersEditView from './views/Admin/AdminOrdersEditView';
import AdminShopAddItemView from './views/Admin/AdminShopAddItemView';

function App() {
  return (
    <SessionProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Navigation />
          <Switch>
            <Route path='/' exact component={HomeView} />
            {/* <Route path='/admin/orders' exact component={AdminOrdersView} />
            <Route path='/admin/shop' exact component={AdminShopView} />
            <Route
              path='/admin/edit-order'
              exact
              component={AdminOrdersEditView}
            />
            <Route
              path='/admin/add-item'
              exact
              component={AdminShopAddItemView}
            /> */}
            <Route path='/for-sale' component={ForSaleView} />
            <Route path='/for-sale-item' component={ForSaleItemView} />
            <Route path='/checkout' component={Checkout} />
            <Route path='/custom' component={CustomOrdersView} />
            <Route path='/custom-order/status' component={CustomOrderStatus} />
            <Route path='/custom-order' component={CustomOrderDescription} />
            <Route path='/gallery' component={GalleryView} />
            <Route path='/contact' component={ContactView} />
            <Route path='/account' component={AccountView} />
            <Route path='/about' component={AboutView} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </SessionProvider>
  );
}

export default App;
